import { Get } from '../helpers';

export default function GetChannelPasscodeListProjectUsage({
  channel,
  signal,
}: {
  channel: number;
  signal?: AbortSignal;
}) {
  return Get<Record<number, string[]>>({
    url: `/v3/admin/content/passcode-lists/${channel}/list-usage`,
    signal,
  });
}
